import React, { useEffect, useState ,Fragment} from "react";
import Cookies from "js-cookie";
import RejuvenationDetailSection from "../components/partials/RejuvenationDetail/RejuvenationDetailSection";
// import WhyRejuvenation from "../components/partials/RejuvenationDetail/WhyRejuvenation";
// import VideoSection from "../components/partials/RejuvenationDetail/VideoSection";

const Rejuvenation = () => {
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");

  useEffect(() => {
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => {
        if (prev !== currentLang) return currentLang;
        return prev;
      });
    }, 1000); // check every second

    return () => clearInterval(interval);
  }, []);
  const content = {
    en: {
      title: "The world’s number\nnumber 1 Brand for\nBeauty Device Systems!",
      text: "These beauty devices yield results that are visible, clinically proven, and powerful, combining revolutionary scientific research and groundbreaking technology.",
    },
    ar: {
      title: "العلامة التجارية رقم 1 عالميًا\nلأجهزة الجمال والعناية بالبشرة!",
      text: "تقدّم هذه الأجهزة نتائج واضحة مثبتة سريريًا وفعّالة، تجمع بين الأبحاث العلمية الثورية والتكنولوجيا المتقدمة.",
    },
  };

  const { title, text } = content[language || "en"];
  return (
    <Fragment>
      <RejuvenationDetailSection
        text={text}
        title={title}
        image={"/assets/images/ProductDetail/Rejuvination-1.jpg"}
      />
      {/* <CollagenDevicesSection language={language} /> */}
    
    </Fragment>
  );
};

export default Rejuvenation;
